// The configured default option for a quick-filter field, or undefined when
// the field has none (or the default is not among the options).
//
// Lists call this as each field's options arrive, which happens after the
// list has restored the user's selection on a soft re-entry (Back, breadcrumb).
// Undefined means "leave the selection alone": writing it into the selection
// would wipe a restored quick filter, which is what four lists used to do.
export function quickFilterDefault(options, field) {
  if (!field || field.filterDefId === null || field.filterDefId === undefined) {
    return undefined
  }
  if (!Array.isArray(options) || options.length === 0) return undefined
  return options.find(a => a[field.dbIdField] === field.filterDefId)
}
